export default function Awards() {
  return (
    <section
      id="awards"
      data-aos="fade-up"
      className="py-20 px-6 bg-white text-gray-800 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto text-left transform transition-transform duration-300 hover:scale-[1.01] hover:shadow-xl rounded-lg p-6 hover:bg-gray-50">
        <h2 className="text-3xl font-bold mb-6 transition-colors duration-300 hover:text-green-700 text-center">
          Awards & Honours
        </h2>

        <ul className="list-disc ml-6 space-y-4 text-lg transition-colors duration-300 hover:text-gray-700">
          <li>
            <strong>Best Paper Award</strong> for{" "}
            <i>
              “NLP-driven Knowledge Extraction and Thematic Classification of Translated Ancient Indian Medical Text”
            </i>{" "}
            presented at the{" "}
            <strong>
              TISS–IATLIS National Conference on “Reimagining LIS Education”
            </strong>
            , conducted by <strong>Tata Institute of Social Sciences (TISS), Mumbai</strong>{" "}
            (<span className="italic">28–29 March 2025</span>).
          </li>
        </ul>
      </div>
    </section>
  );
}
